import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const AwakAdvanceUtility = ({ includeYearCode = true }) => {
   const apiUrl = `${process.env.REACT_APP_API}/getall-AwakAdvanceData`;
   const columns = [
      { label: "Doc No", key: "Doc_No" },
      { label: "Doc Date", key: "Doc_Date" },
      { label: "Farmer", key: "Ac_Name_E" },
      { label: "Advance Type", key: "Advance_Type" },
      { label: "Advance", key: "Advance" },
   ];
   return (
      <TableUtility
         title="Awak Advance"
         apiUrl={apiUrl}
         columns={columns}
         rowKey="Id"
         addUrl="/Awakadvance-api"
         detailUrl="/Awakadvance-api"
         permissionUrl="/Awaka-advance-utility"
         includeYearCode={includeYearCode}

      />
   );

};


export default AwakAdvanceUtility;